import React from 'react';
import type { FiyatYonu } from '../../utils/fiyatKarsilastirma';

// Aynı yön iki geçmişte ters renk alır: satış fiyatının artışı lehimize (yeşil),
// maliyetin (malzeme fiyatının) artışı aleyhimize (kırmızı).
export const SATIS_FIYATI_RENKLERI: Record<FiyatYonu, string> = {
  artis: 'text-green-700',
  azalis: 'text-red-600',
};
export const MALIYET_RENKLERI: Record<FiyatYonu, string> = {
  artis: 'text-red-600',
  azalis: 'text-green-700',
};

interface FiyatGecmisiSatiriProps {
  /** Biçimlenmiş eski fiyat; null ise eski fiyat ve ok çizilmez (ilk kayıt). */
  eski: string | null;
  /** Biçimlenmiş yeni fiyat. */
  yeni: string;
  yon: FiyatYonu | null;
  renkler: Record<FiyatYonu, string>;
  kim: string;
  tarih: string;
  not?: string | null;
}

/**
 * Fiyat geçmişinin tek satırı (ürün ve malzeme ortak): eski → yeni, değiştiren, tarih,
 * varsa not. Yalnız çizer; yön ve biçim çağırandan gelir.
 */
const FiyatGecmisiSatiri: React.FC<FiyatGecmisiSatiriProps> = ({ eski, yeni, yon, renkler, kim, tarih, not }) => (
  <div className="py-1.5 px-2 rounded bg-white border border-gray-100 text-xs" data-testid="fiyat-gecmisi-satiri">
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        {eski !== null && (
          <>
            <span className="font-mono text-gray-400 whitespace-nowrap">{eski}</span>
            <span className="text-gray-300">→</span>
          </>
        )}
        <span className={`font-mono font-bold whitespace-nowrap ${yon ? renkler[yon] : 'text-gray-700'}`} data-yon={yon || ''}>
          {yeni}
        </span>
      </div>
      <div className="flex items-center gap-2 text-gray-400 min-w-0">
        <span className="truncate">{kim}</span>
        <span className="whitespace-nowrap">{tarih}</span>
      </div>
    </div>
    {not && <p className="mt-1 text-gray-600 break-words">{not}</p>}
  </div>
);

export default FiyatGecmisiSatiri;
